export const TERRAIN_THEME = {
    BORDER_OPACITY: 1,
    FILL_OPACITY: 0.1,
    COLOR: {
        0: '199, 100%, 30%',
        1000: '139, 70%, 35%',
        2000: '104, 46%, 56%',
        3000: '60, 25%, 100%',
        4000: '35, 97%, 75%',
        5000: '18, 85%, 62%',
        6000: '24, 67%, 37%'
    }
};
